"use client"

import { create } from "zustand"
import {
    IDLE_ISLAND_STATE,
    islandWilsonReducer,
    type IslandLanding,
    type IslandRun,
    type IslandWilsonAction,
    type IslandWilsonState,
} from "@/components/desktop/islandWilson.utils"

interface WilsonActivityStore extends IslandWilsonState {
    reportRun: (params: { key: string; run: IslandRun }) => void
    endRun: (key: string) => void
    landRun: (params: { key: string; landing: IslandLanding }) => void
    clearLanding: () => void
}

export const useWilsonActivityStore = create<WilsonActivityStore>()(set => {
    const apply = (action: IslandWilsonAction) =>
        set(state =>
            islandWilsonReducer(
                { runs: state.runs, landing: state.landing },
                action
            )
        )
    return {
        ...IDLE_ISLAND_STATE,
        reportRun: ({ key, run }) => apply({ type: "runReported", key, run }),
        endRun: key => apply({ type: "runEnded", key }),
        landRun: ({ key, landing }) =>
            apply({ type: "runLanded", key, landing }),
        clearLanding: () => apply({ type: "landingCleared" }),
    }
})
